import "./checkbullet.css"
import "./checkbullet.css";
import { Icon } from "@/components/ui/Icon"
import { Circle } from "lucide-react";

type CheckBulletProps = {
  checked: boolean;
  text: string;
};

function CheckBullet({
  checked = false,
  text
}: CheckBulletProps) {
  return (
    <div className="check-bullet inline-flex align-items-center items-center">

      {checked ? (
        <Icon name="StreamlineEssentialCheckCircle1Bold" size="sm" className="text-[var(--surface-primary-fixed-hover)]" />
      ) : (
        <Circle className="w-9 text-[var(--greyCredentials)]" fill={"var(--greyCredentials)"} />
      )}

      <span className="ml-4 text-[var(--on-surface-variant)]" style={{ fontSize: 15 }}>
        {text}
      </span>
    </div>
  );
}

export default CheckBullet;